var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 30.6351,
    height: 30.6351,
    rx: 3.75,
    fill: "#DAF9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 30.6351,
    height: 30.6351,
    rx: 3.75,
    stroke: "#91E0DF",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3722_8380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4583 13.982C17.5734 13.982 17.6667 13.8887 17.6667 13.7736C17.6667 13.6586 17.5734 13.5653 17.4583 13.5653M17.4583 13.982C17.3433 13.982 17.25 13.8887 17.25 13.7736C17.25 13.6586 17.3433 13.5653 17.4583 13.5653M17.4583 13.982V13.5653",
    stroke: "#0DB5B5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8335 11.4819L20.1668 19.8153",
    stroke: "#0DB5B5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.208 19.5235C17.6743 19.607 16.9708 19.607 15.9998 19.607C14.2374 19.607 13.3563 19.607 12.7718 19.1078C12.6888 19.0369 12.6115 18.9596 12.5407 18.8766C12.0415 18.2922 12.0415 17.411 12.0415 15.6486C12.0415 14.6777 12.0415 13.9742 12.125 13.4404M19.348 18.9968C19.3865 18.9582 19.4236 18.9181 19.459 18.8766C19.9582 18.2922 19.9582 17.411 19.9582 15.6486C19.9582 13.8863 19.9582 13.0051 19.459 12.4206C19.3881 12.3376 19.3108 12.2603 19.2278 12.1895C18.6434 11.6903 17.7622 11.6903 15.9998 11.6903C14.2374 11.6903 13.3563 11.6903 12.7718 12.1895C12.7303 12.2249 12.6903 12.2619 12.6517 12.3005",
    stroke: "#0DB5B5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.3153L14.1251 15.4405M19.75 17.3153L18.721 16.2863C18.5795 16.1448 18.3876 16.0653 18.1875 16.0653C17.9874 16.0653 17.7955 16.1448 17.654 16.2863L17.1458 16.7945",
    stroke: "#0DB5B5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3722_8380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(11 10.6486)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.d354d849291681bedf64062967c50d3a.svg";
export { ForwardRef as ReactComponent };